import reducer from './workbenches.reducer';
import actions from './workbenches.actions';
import selectors from './workbenches.selectors';

export default {
  reducer,
  actions,
  selectors,
};
